import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import AllSubscriptions from '../models/AllSubscriptions';

export interface SubscriptionStateType {
  allSubscriptions: AllSubscriptions | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: SubscriptionStateType = {
  allSubscriptions: null,
  isLoading: false,
  error: null,
};

export const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    setAllSubscriptions: (state, action: PayloadAction<AllSubscriptions>) => {
      state.allSubscriptions = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setSubscriptionLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSubscriptionError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearSubscriptionData: state => {
      state.allSubscriptions = null;
      state.error = null;
      state.isLoading = false;
    },
  },
});

export const {
  setAllSubscriptions,
  setSubscriptionLoading,
  setSubscriptionError,
  clearSubscriptionData,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
